import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../auth'
import type { Role } from '../types'

export function RequireAuth() {
  const { user } = useAuth()
  const loc = useLocation()
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />
  return <Outlet />
}

export function RequireRole({ min }: { min: Role }) {
  const { hasRole } = useAuth()
  if (!hasRole(min)) return <Navigate to="/" replace />
  return <Outlet />
}
